<template>
  <v-dialog v-model="dialog" max-width="800px" fullscreen persistent>
    <v-card>
      <v-card-title dark class="dialog-header">
        <span>{{ fileDesc }}</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="max-height: 950px" class="mt-2">
        <v-row>
          <v-col cols="12">
            <div class="py-1">
              <iframe :src="source" width="100%" height="700"> </iframe>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
export default {
  props: {
    data: null,
  },

  data() {
    return {
      dialog: false,
      source: null,
      isLoading: true,
      fileDesc: null,
      page: null,
      pageCount: 1,
      showAllPages: true,
      shortlistfile: null,
    };
  },
  watch: {
    data: {
      handler(data) {
        if (data) {
          console.log(data);
          this.fileDesc = data.filedesc;
          this.source =
            process.env.VUE_APP_SERVER +
            "/opcr-target/view/opcr-accomplishment/" +
            data.filename +
            "#toolbar=0";
          this.dialog = true;
        }
      },
      deep: true,
    },
    showAllPages() {
      this.page = this.showAllPages ? null : 1;
    },
  },
  methods: {
    close() {
      //   this.eventHub.$event("CloseShortFileView", false);
      this.dialog = false;
    },
    handleDocumentRender() {
      this.isLoading = false;
      this.pageCount = this.$refs.pdfRef.pageCount;
    },
  },
};
</script>
